<app-left-side-nav></app-left-side-nav>
<app-header *ngIf="!isMobileDevice"></app-header>
<div class="afterLoginPageContainer">
    <div class="container p-0">
        <div class="mainContent">
            <div class="assign_ticket">
                <div class="px-3 py-2 d-flex justify-content-between align-items-center">
                    <div class="top-heading">
                        <h4 class="mb-0">Fill up the ticket form</h4>
                    </div>
                </div>

                <div class="myTkt d-flex align-items-center justify-content-between" 
                *ngIf="showMyTicketsLink || (userEventStatus?.event_my_tickets?.assigned_tickets_bought_by_me ?? 0) > 0">
                    <p class="mb-0">To view assigned ticket, go to</p>
                    <a class="myTktBtn font-weight-600" routerLink="/reg/my-tickets">My Tickets</a>
                </div>

                <div class="ticketList pb-3" *ngIf="assignForms && assignForms.length > 0 && eventDetails?.allow_to_register === 1">
                    <div class="px-3" *ngFor="let ticket of tickets; let i = index; trackBy: trackByTicketId"
                        [ngClass]="{ 'border_btm': tickets.length > 1 && i < tickets.length - 1 }">
                        <div class="assign" [ngClass]="ticket.ticket_type_code + '_div'" [ngStyle]="{
                        'border-color': (ticket.is_child
                        ? (previewLogos[i] && previewLogos[i] !== '/assets/images/Default-profile-photo.png' && getForm(i).valid ? '#008B44' : '#AEAEAE')
                        : (getForm(i).valid ? '#008B44' : '#AEAEAE'))
                        }">
                          <p *ngIf="error_messages[i]" class="assigned_err px-3 pt-2 mb-0">Please do not assign multiple tickets to the same person.<br class="line-break"> Upgrade your ticket for better benefits.</p>
                            <div class="p-3 head d-flex align-items-center justify-content-between" [ngStyle]="{
                                'border-color': getForm(i).valid ? '#008B44' : '#AEAEAE',
                                }">
                                <div class="d-flex align-items-center">
                                    <span class="fw-bold visitor-no">Visitor {{ ticket.display_index }}</span>
                                    <span class="ms-3 font-weight-600 tkt-type-name" translate="no"
                                        [ngStyle]="{ 'background-color': AssignTicketIcons[ticket.ticket_type_code]?.primary }">
                                        <img class="me-1 icon-white-small"
                                            src="{{ AssignTicketIcons[ticket.ticket_type_code]?.white }}" alt="Visitor">
                                        {{ ticket.ticket_type_name }}</span>
                                </div>
                                <div class="customRadio"
                                *ngIf="!(userEventStatus?.event_my_tickets?.tickets_assigned_for_me) 
                                && !ticket.is_child 
                                && !hideMyselfOption 
                                && (selectedMyselfIndex === null || selectedMyselfIndex === i)">
                                    <label class="custom-control-label">
                                        <input type="checkbox" [checked]="selectedMyselfIndex === i"
                                            (change)="onMyselfChecked($event, i)">
                                        <span class="checkmark"></span>
                                        <span> Myself</span>
                                    </label>
                                </div>
                               </div>
                            <form class="assign-form p-3" *ngIf="getForm(i)" [formGroup]="getForm(i)"
                                (ngSubmit)="onSubmit(i)">
                                <div class="px-0">
                                    <div class="d-flex">
                                        <div class="photo d-flex justify-content-center flex-column">
                                            <div class="imgOut">
                                                <label [for]="'profilepic-' + i">
                                                    <div class="img-box"
                                                        title="Image should be jpg, jpeg, png and less than 15 MB">
                                                        <img id="myImg" name="myImg"
                                                            [src]="previewLogos[i] || '/assets/images/Default-profile-photo.png'"
                                                             onerror="this.src='/assets/images/Default-profile-photo.png';"

                                                            alt="profile photo">
                                                        <span><i class="fa fa-pen"></i></span>
                                                     
                                                    </div>
                                                   
                                                </label>
                                              
                                                <input [id]="'profilepic-' + i" name="profilepic" type="file"
                                                    accept=".jpg,.jpeg,.png" class="d-none"
                                                    (change)="onProfileLogoSelected($event,i)" />
                                            </div>
                                            
                               
                                            <div class="err_msg image-err-msg my-2">
                                                <p class="note mb-0" *ngIf="requiresProfilePhoto(ticket)"><span class="imp">* </span>Profile photo required.</p> 
                                                <p class="mt-1">{{ invalidImages[i] }}</p></div>
                                        </div>
                                        <div class="info ms-5 w-100">
                                            <div class="inputOuter">
                                                <input type="text" class="form-control" placeholder="First Name"
                                                    formControlName="firstName" aria-label="First Name" maxlength="60"
                                                    (keydown)="preventLeadingSpace($event)"
                                                    (click)="openSuggestionsFor(i)"
                                                    (keypress)="restrictInvalidChars($event)"
                                                    (paste)="onPasteRemoveConsecutiveSpaces($event, 'firstName', 60, getForm(i))"
                                                    (input)="enforceMaxLength($event, 60, getForm(i).get('firstName'))">

                                                <div class="error_msg_container">
                                                    <span class="err_msg"
                                                        *ngIf="getForm(i).get('firstName')?.touched && getForm(i).get('firstName')?.errors?.['required']">
                                                        First name is required.
                                                    </span>
                                                    <span class="err_msg"
                                                        *ngIf="getForm(i).get('firstName')?.value?.length === 60
                                                                        && !getForm(i).get('firstName')?.errors?.['startsWithLetter']
                                                                        && !getForm(i).get('firstName')?.errors?.['invalidName']
                                                                        && !getForm(i).get('firstName')?.errors?.['consecutiveSpecials']">
                                                        Maximum 60 characters.
                                                    </span>

                                                    <span class="err_msg" class="text-danger errorMsg"
                                                        *ngIf="getForm(i).get('firstName')?.errors?.['minlength']">
                                                        Minimum 1 character required.
                                                    </span>
                                                    <span class="err_msg"
                                                        *ngIf="getForm(i).get('firstName')?.errors?.['startsWithLetter']
                                                                        || getForm(i).get('firstName')?.errors?.['invalidName']
                                                                        || getForm(i).get('firstName')?.errors?.['consecutiveSpecials']">
                                                        Invalid First Name.
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="inputOuter">
                                                <input type="text" class="form-control" placeholder="Last Name"
                                                    formControlName="lastName" aria-label="Last Name" maxlength="60"
                                                    (keydown)="preventLeadingSpace($event)"
                                                     (click)="openSuggestionsFor(i)"
                                                    (keypress)="restrictInvalidChars($event)"
                                                    (paste)="onPasteRemoveConsecutiveSpaces($event, 'lastName', 60, getForm(i))"
                                                    (input)="enforceMaxLength($event, 60, getForm(i).get('lastName'))">

                                                <div class="error_msg_container">
                                                    <span class="err_msg"
                                                        *ngIf="getForm(i).get('lastName')?.touched && getForm(i).get('lastName')?.errors?.['required']">
                                                        Last name is required.
                                                    </span>
                                                    <span class="err_msg"
                                                        *ngIf="getForm(i).get('lastName')?.value?.length === 60
                                                                        && !getForm(i).get('lastName')?.errors?.['startsWithLetter']
                                                                        && !getForm(i).get('lastName')?.errors?.['invalidName']
                                                                        && !getForm(i).get('lastName')?.errors?.['consecutiveSpecials']">
                                                        Maximum 60 characters.
                                                    </span>

                                                    <span class="err_msg" class="text-danger errorMsg"
                                                        *ngIf="getForm(i).get('lastName')?.errors?.['minlength']">
                                                        Minimum 1 character required.
                                                    </span>
                                                    <span class="err_msg"
                                                        *ngIf="getForm(i).get('lastName')?.errors?.['startsWithLetter']
                                                                        || getForm(i).get('lastName')?.errors?.['invalidName']
                                                                        || getForm(i).get('lastName')?.errors?.['consecutiveSpecials']">
                                                        Invalid last name.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="info">
                                    <div class="inputOuter">
                                        <app-mobile-input formControlName="mobile"
                                         (click)="openSuggestionsFor(i)"
                                            (mobileChange)="onMobileChange($event, i)"></app-mobile-input>
                                        <div
                                            *ngIf="getForm(i).get('mobile')?.invalid && (getForm(i).get('mobile')?.dirty || getForm(i).get('mobile')?.touched)">
                                            <small *ngIf="getForm(i).get('mobile')?.errors?.['required']"
                                                class="text-danger err_msg mt-2">Mobile number is required.</small>
                                            <small *ngIf="getForm(i).get('mobile')?.errors?.['pattern']"
                                                class="text-danger err_msg mt-2"> Mobile number must contain at least 6
                                                digits.</small>
                                        </div>
                                    </div>
                                    <div class="inputOuter">
                                        <select id="inputState" class="form-select" formControlName="state"
                                            [ngClass]="{ 'prefilled-disabled': ticket.is_child }" required>
                                            <option value="" selected disabled>State</option>
                                            <option *ngFor="let s of states" [value]="s">{{ s }}</option>
                                        </select>
                                        <div class="text-danger err_msg mt-2"
                                            *ngIf="getForm(i).get('state')?.touched && getForm(i).get('state')?.hasError('required')">
                                            State is required.
                                        </div>
                                    </div>
                                    <div class="inputOuter">
                                        <select id="inputCity" class="form-select" formControlName="city"
                                            [ngClass]="{ 'prefilled-disabled': ticket.is_child }" required>
                                            <option value="" selected disabled>City</option>
                                            <option *ngFor="let c of ticketCities[i]" [value]="c">{{ c }}</option>
                                        </select>
                                        <div class="text-danger err_msg mt-2"
                                            *ngIf="getForm(i).get('city')?.touched && getForm(i).get('city')?.hasError('required')">
                                            City is required.
                                        </div>
                                    </div>
                                    <input type="hidden" formControlName="isHistory">
                                    <div class="text-center btn-wrapper">
                                        <button class="btn btnAct font-weight-600" type="button"
                                            [disabled]="isAssignDisabled(i)" [ngStyle]="{
                                            'background-color': isAssignDisabled(i) ? '#EEEEEE' : '#008B44',
                                            'color': isAssignDisabled(i) ? '#414141' : '#FFFFFF',
                                            'cursor': isAssignDisabled(i) ? 'not-allowed' : 'pointer'
                                            }" (click)="openConfirmationModal(i)">
                                            Assign Ticket
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div *ngIf="showRegClosedMsg">
                    <h6 class="text-center mt-4">
                        KISAN 2025 has concluded, and registrations are now closed.
                        Stay tuned for updates on KISAN 2026.
                    </h6>
                </div>
            </div>
        </div>
    </div>

    <!-- Payment Success Modal -->
    <!-- <div #PaymentSuccessModal class="modal" id="paymentSuccessModal" tabindex="-1"
        aria-labelledby="PaymentSuccessModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content green">
                <div class="text-end">
                    <button type="button" class="btn" data-bs-dismiss="modal"><i
                            class="fa-solid fa-xmark green"></i></button>
                </div>
                <div class="modal-body text-center mt-3">
                    <h1 class="mb-0 fw-bold"><span>Congrats!</span> <br> Payment Successful. </h1>
                    <img class="mb-3" src="/assets/images/payment-success copy.gif" />
                    <p class="mb-4">You have saved <span class="amt font-weight-600 ms-1">₹ {{ discount }}</span></p>

                    <button class="font-weight-600 mt-3" data-bs-dismiss="modal">Okay, Thanks</button>
                </div>
            </div>
        </div>
    </div> -->

    <!-- Suggestions Modal -->
<!-- Modal -->
<div class="modal fade" id="SuggestionsModal" tabindex="-1" aria-labelledby="SuggestionsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body text-center pt-4 pb-4 mt-2">
        <button type="button" class="btn" data-bs-dismiss="modal"><i class="fa-solid fa-xmark"></i></button>
        <h2 class="mb-2 font-weight-600 green">History Based Suggestions</h2>
        <h6 class="mb-4">You have booked tickets for them before.</h6>

        <div class="list">
          <!-- Empty state -->
          <div *ngIf="!suggestions?.length" class="text-muted mb-2">No suggestions found.</div>

          <!-- Render list -->
          <div class="d-flex align-items-center user mb-3"  (click)="useSuggestion(s)"
    (keydown.enter)="useSuggestion(s)"
    (keydown.space)="useSuggestion(s)"    role="button" *ngFor="let s of suggestions">
            <div class="imgOuter me-3">
              <img [src]="cleanImageUrl(s.image_url) || '/assets/images/default-profile-individual.png'"
              (error)="onListImgError($event, s)"
                   alt="Profile"
                  />
            </div>
            <div class="info text-start">
              <h4 class="mb-0 name">{{ s.first_name }} {{ s.last_name }}</h4>
              <p class="mb-0 details">
                {{ formatMobile(s.mobile) }} |
                {{ s.city }}<span *ngIf="s.state">, {{ s.state }}</span>
              </p>
            </div>
             
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


    <!-- Confirmation Modal -->
    <div #ConfirmationModal class="modal fade conf" id="ConfirmationModal" tabindex="-1"
        aria-labelledby="LoyaltyModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-bottom">
            <div class="modal-content">
                <div class="text-end mt-3 me-3">
                    <button type="button" class="btn close_btn" data-bs-dismiss="modal"><i
                            class="fa-solid fa-xmark"></i></button>
                </div>
                <div class="modal-body text-center pt-0">
                    <h1 class="mb-5 fw-bold">Confirmation</h1>
                    <h6 class="mb-5"> Are you sure? <br>Once you assign the ticket,<br> it cannot be changed.</h6>
                    <button class="font-weight-600 btns" type="button"
                        (click)="onSubmit(selectedIndex)">Confirm</button><br>
                    <button class="font-weight-600 mt-3 btns cancel" data-bs-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>

    <div #SuccessModal class="modal fade conf success-modal" id="SuccessModal" tabindex="-1"
        aria-labelledby="LoyaltyModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-bottom">
            <div class="modal-content">
                <div class="text-end mt-3 me-3">
                    <button type="button" class="btn" data-bs-dismiss="modal"><i class="fa-solid fa-xmark"></i></button>
                </div>
                <div class="modal-body text-center pt-0">
                    <img src="/assets/images/loyalty.gif" width="250px" />
                    <h1 class="mb-4 fw-bold green">Ticket Assigned <span class="d-block mt-2">Successfully.</span></h1>
                    <h6 class="mb-4"> You can see the detailed ticket with <br> QR code in <a
                            routerLink="/reg/my-tickets" class="font-weight-600 link">my tickets</a> option.</h6>
                    <button class="font-weight-600 mt-3 btns" (click)="onNextClick()">Next</button>
                </div>
            </div>
        </div>
    </div>

    <app-support-button [phone]="supportPhone"></app-support-button>
</div>